import type * as webResolversSync from './webResolversSync';
import { LazyBootModule, LazyImport } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof webResolversSync> = new LazyBootModule<
    typeof webResolversSync
>(() => import(/* webpackChunkName: "WebResolvers" */ './webResolversSync'), {
    name: 'WebResolvers',
});

export const lazyWebResolvers: LazyImport<typeof webResolversSync.webResolvers, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.webResolvers);
